'use strict';

const cachedActivityCodesForBillingCentre = [],
    southernHemisphereYearChange = 8; // SH - Aug

const _addActivityToDraftHelpers = {

    async missingCoverCheck({ uniqueHorseIDs, season, activityDate } = {}){

        var checkURL = '/components/breeding.cfc?' +
        jQuery.param({
            'method': 'checkExistingCoversWeb',
        });

        try {
            const response = await fetch(checkURL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    'horseIDs': uniqueHorseIDs.join(','),
                    'season': season,
                    'activityDate': activityDate,
                    'returnMissingOnly': 'true',
                }),
            });
            const existingCoverResult = await response.json();
            const coverResultValidation = handleError(existingCoverResult);
            return coverResultValidation ? _addActivityToDraftHelpers.missingCoverCheckPopup({
                maresWithMissingCovers: coverResultValidation.data,
                season: season,
            }) : null;
        } catch (error) {
            _addActivityToDraftHelpers.handleError(error);
            return null;
        }
    },

    missingCoverCheckPopup({ maresWithMissingCovers, season } = {}){

        var result = {
            'missingCoversFound': false,
            'success': true,
            'message': '',
        };

        if (maresWithMissingCovers.length < 1) {
            return result;
        }

        var coverMsg = 'In order to record a Breeding Status, ' +
        'a Cover for the <strong>' + season +
        ' Season</strong> must exist for the following Mares: <br>';

        maresWithMissingCovers.forEach((mare, index) => {
            if (index > 0){
                coverMsg += ', ';
            }
            coverMsg += '<br><strong>' + mare.name + '</strong>';
        });

        coverMsg += '<br><br> Please add a Cover Record for each';
        coverMsg += ' affected Mare before continuing.';

        EQLAPP.STRIPE.showAlert({
            title: 'Warning',
            icon: 'warning',
            body: coverMsg,
        });

        $('#addActivityWait').customHide();
        $('#addActivity').customShow();

        return null;
    },

    async checkForDuplicates({ uniqueHorseIDs, ActivityCodeID, activityDate } = {}){

        const result = {
            'success': false,
            'matchingRecords': '',
            'message': '',
        };

        var checkURL = 'components/daily.cfc?' +
        jQuery.param({
            'method': 'checkMatchingActivityDetails',
            'horseIDs': uniqueHorseIDs.join(','),
            'activityID': ActivityCodeID,
            'actvityDate': activityDate,
            'countOnly': 'true',
        });

        const response = await fetch(checkURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const matchingActivitiesResult = await response.json();
        if (!isInt(matchingActivitiesResult)) {
            result.success = false;
            result.message = matchingActivitiesResult;
        } else {
            result.success = true;
            result.matchingRecords = matchingActivitiesResult;
        }
        return result;
    },

    showDuplicatePopup({
        uniqueHorseIDs,
        activityDate,
        activityDesc,
        ActivityCodeID,
    } = {}){
        activityDesc = encodeURI(activityDesc);

        pop_win(
            'ajax_generic_window.cfm',
            'pop_daily_activity_add_dup_confirm',
            '',
            '',
            '',
            false,
            '&horseIDs=' + uniqueHorseIDs + '&activityID=' + ActivityCodeID +
            '&actvityDate=' + activityDate +
            '&activityDesc=' + activityDesc,
            '',
            'Activity Add Confirmation',
            780,
            360,
        );
    },

    async save({ uniqueHorseIDs, ActivityCodeID, activityDate } = {}){

        try {
            const response = await _addActivityToDraftHelpers.checkForDuplicates({
                uniqueHorseIDs: uniqueHorseIDs,
                ActivityCodeID: ActivityCodeID,
                activityDate: activityDate,
            });
            const activityDesc = $('#ActivityCode_ID option:selected').text();

            if (response.matchingRecords > 0) {

                // Shows a duplicate popup to user and lets them choose to add or skip
                _addActivityToDraftHelpers.showDuplicatePopup({
                    uniqueHorseIDs: uniqueHorseIDs,
                    activityDate: activityDate,
                    ActivityCodeID: ActivityCodeID,
                    activityDesc: activityDesc,
                });

            } else {
                // Save Input
                _addActivityToDraftHelpers.saveForm();
            }
        } catch (error) {
            console.log(error);
            const saveResult = {
                'success': false,
                'matchingRecords': '',
                'message': '',
            };
            saveResult.message = 'An unknown error occured';
            return saveResult;
        }
    },
    saveForm(){

        const formID = 'daily_activity_input';
        const formObj = $('#' + formID);

        if (formObj.valid()){

            var activityInputType = $('#activityInputType').val();
            var activityInputType = formObj.find('[name="activityInputType"]').val();
            var revisitDateIDSelector = formObj.find('.js-frmRevisitDateID').attr('name');
            var nextActivityID = formObj.find('[name="Next_ActivityCode_ID"]').val() ?? '';
            var revisitDate = $('#' + revisitDateIDSelector).val()?.trim() ?? '';

            // Check that valid Revisit
            // and Next Treatment combination have been selected
            if (
                (
                    activityInputType == 'vet' ||
                    activityInputType == 'farrier' ||
                    activityInputType == 'cover'
                ) &&
                !checkValidRevisit({
                    revisitDate: revisitDate,
                    nextActivityID: nextActivityID,
                })
            )
            {
                $('#addActivityWait').customHide();
                $('#addActivity').customShow();
                return;
            }

            // Save Form to DB
            saveForm(formID);

            // Display Draft Section
            if (!$('#jq_daily_draft_container').is(':visible')){
                if ($('#daily_horse_ids').val() != '' &&
                    $('#ActivityCode_ID').val() != ''){
                    $('#sectionTopBar_3').trigger('click');
                }
            }

            addedToDraft = true;

        }
    },

    handleError(error){
        console.log(error);
        alert('An error occured. Please try again.');
        $('#addActivityWait').customHide();
        $('#addActivity').customShow();
        return null;
    },

};

function handleError(response){
    if (!response.success) {
        alert(response.error.message);
    }
    return response;
}

export function addActivityToDraft({ addActivityButtonObj, inputType } = {}){
    var selectedHorseIDs = get_selected_daily_horse_ids();
    var uniqueHorseIDs = [];
    var ActivityCodeID = $('#ActivityCode_ID').val();

    const formID = 'daily_activity_input';
    const formObj = $('#' + formID);

    if (formObj.valid()){

        // Hide Add to Draft List Button
        addActivityButtonObj.customHide();

        //Make sure no duplicate ids before entering
        $.each(selectedHorseIDs, (i, el) =>{
            if ($.inArray(el, uniqueHorseIDs) === -1) uniqueHorseIDs.push(el);
        });

        if (!$('.js_daily_activity_input').validate().element('#Charge')) {
            return;
        }

        $('#addActivityWait').customShow();
        $('#daily_horse_ids').val(uniqueHorseIDs.toString());
        var activityDate = $('#activityDate').val();

        // Only Allow 1 horse to be selected if using cover
        if (inputType === 'cover'){
            var selectedCountArray = dailyGetHorseList({
                selectedOnly: true,
            });

            if (selectedCountArray.length > 1){
                var bodyMessage = 'There is more than 1 mare selected.';
                bodyMessage += '\nPlease select only 1 Mare for the Cover Activity';
                EQLAPP.STRIPE.showAlert({
                    title: 'Alert',
                    body: bodyMessage,
                });
                $('#addActivityWait').customHide();
                $('#addActivity').customShow();
                return false;
            }

        }

        //Check Mare Status and if Existing Covers
        if (inputType === 'vet'){
            var mareStatus = $('#MareStatus').val();
            var season = $('#SeasonVet').val();

            if (fromBreeding){
                if (mareStatus == '') {
                    EQLAPP.STRIPE.showAlert({
                        title: 'Alert',
                        body: 'Please select a Mare Status.',
                    });
                    $('#addActivityWait').customHide();
                    $('#addActivity').customShow();
                    return false;
                }
            }

            if (mareStatus !== '') {
                var inFoal = $('#MareStatus').find(':selected').data('in-foal');

                if (inFoal.length > 0 && inFoal === 'Y'){

                    _addActivityToDraftHelpers.missingCoverCheck({
                        uniqueHorseIDs: uniqueHorseIDs,
                        season: season,
                        activityDate: activityDate,
                    })
                        .then(response => {

                            if (response === null){
                                return;
                            }

                            if (!response.success){
                                alert(response.message);
                                return;
                            }

                            _addActivityToDraftHelpers.save({
                                uniqueHorseIDs: uniqueHorseIDs,
                                ActivityCodeID: ActivityCodeID,
                                activityDate: activityDate,
                            });

                        })
                        .catch(() => _addActivityToDraftHelpers.handleError);

                } else {
                    _addActivityToDraftHelpers.save({
                        uniqueHorseIDs: uniqueHorseIDs,
                        ActivityCodeID: ActivityCodeID,
                        activityDate: activityDate,
                    });
                }
            } else {
                _addActivityToDraftHelpers.save({
                    uniqueHorseIDs: uniqueHorseIDs,
                    ActivityCodeID: ActivityCodeID,
                    activityDate: activityDate,
                });
            }
        } else {
            _addActivityToDraftHelpers.save({
                uniqueHorseIDs: uniqueHorseIDs,
                ActivityCodeID: ActivityCodeID,
                activityDate: activityDate,
            });
        }
    }

}

export function activityDateChanged(options) {
    /*
        options (* = required)
            formSelector*
            seasonSelectorVet*
            seasonSelectorCover*
            hemisphere - defaults to 'N'

    */

    if (!options.hasOwnProperty('formSelector') || options.formSelector.length < 1) {
        console.log('Invalid formSelector passed to activityDateChanged');
        return;
    }

    const $dailyInputForm = $(options.formSelector);
    const accountHemisphere = options.hasOwnProperty('hemisphere')
        ? options.hemisphere
        : 'N';

    const activityDate = $dailyInputForm.find('.js-activity-date').val();

    // Season Combos
    const $seasonControlVet = $dailyInputForm.find(options.seasonSelectorVet);
    const $seasonControlCover = $dailyInputForm.find(options.seasonSelectorCover);

    // Parse activity date
    const activityDateObject = new Date(activityDate);
    const activityYear = activityDateObject.getFullYear();
    const activityMonth = activityDateObject.getMonth() + 1;

    if (accountHemisphere === 'N' || activityMonth >= southernHemisphereYearChange) {
        // NH OR After August (Covers SH new season)
        $seasonControlVet.val(activityYear);
        $seasonControlCover.val(activityYear);
    } else {
        // SH before Sept
        if (activityMonth < southernHemisphereYearChange) {
            $seasonControlVet.val(activityYear - 1);
            $seasonControlCover.val(activityYear - 1);
        }
    }

}

export function getActivityCodesForBillingCentre(options) {

    /*
        options{
            billingCentreID - if provided will only return codes for that billing centre
            ActivityType_ID - activity type filter
            callback - a function to call after codes are retrieved
            currentActivityCode - current activity code
        }
    */
    var cacheID = options.billingCentreID + '_' + options.ActivityType_ID;
    var useCache = options.hasOwnProperty('useCache')
        ? options.useCache
        : false;

    if (useCache && cachedActivityCodesForBillingCentre[cacheID]) {
        options.callback(cachedActivityCodesForBillingCentre[cacheID]);
    } else {

        var activityCodeURL = jQuery.param.querystring('/components/daily.cfc?', {
            'method': 'getActivityCodesWeb',
            'billingCentreIDOnly': options.billingCentreID,
            'ActivityType_ID': options.ActivityType_ID,
            'currentActivityCode': options.currentActivityCode,
            'excludeMareActivities': options.excludeMareActivities,
            'mareOnly': options.mareOnly,
            'Vaccination_ID': options.vaccinationID,
            'nvpsOnly': options.nvpsOnly,
            'activeOnly': true,
        });

        $.ajax({
            type: 'GET',
            url: activityCodeURL,
            data: gen_random(),
            cache: false,
            success: function (data){
                cachedActivityCodesForBillingCentre[cacheID] = data;
                options.callback(cachedActivityCodesForBillingCentre[cacheID]);
            },
            error: function (){
                alert('Failed to load popup contents');
            },
        });

    }
}

export function createActivityCodeAutocomplete(options) {

    /*
        options:{
            controlSelector,
            data,
            containerSelector,
            onChange,
            currentActivityCode
        }
    */

    // saveID, as lose ref to jquery obj when rebuilt
    var controllerID = options.controlSelector.attr('id');
    var selectElement = $('<select>').attr({
        id: controllerID, // Set the id
        name: controllerID, // Set the name
    });

    // Add options to the select element
    var usesBreeding = true;
    var currentCode = 0;
    var sexID = 0;

    var option = $('<option>');
    selectElement.append(option); // add blank option

    options.data.forEach((activityCode) =>{

        if (!activityCode.Active && activityCode.ID !== currentCode) {
            return; // skip all inactive codes unless its the current code
        }

        if (!usesBreeding && activityCode.MareOnly == 1) {
            return; // skip all mare codes if user does not use breeding
        }

        if (sexID === 3 && activityCode.MareOnly !== 1) {
            return; // exclude mare only codes if sexID is not 3 (i.e. a mare)
        }

        // Class
        var optionClass = 'all';
        if (activityCode.MareOnly === 1) {
            optionClass = 'M';
        } else if (activityCode.Gelding === 1) {
            optionClass = 'Gelding';
        } else {
            optionClass = 'all';
        }

        option = $('<option>')
            .val(activityCode.ID)
            .text(activityCode.Description)
            .addClass(optionClass)
            .attr('medicine', activityCode.Medicine)
            .attr('abbrv', activityCode.Abbreviation);

        if (options.currentActivityCode === activityCode.ID) {
            option.attr('selected', 'selected');
        }

        selectElement.append(option);
    });

    // Append the select element to the container div
    options.containerSelector
        .empty()
        .append(selectElement)
        .unbind('change')
        .bind('change', options.onChange);
    var newComboControl = options.containerSelector.find('#' + controllerID);
    newComboControl.combobox();
    options.containerSelector
        .find('.custom-combobox-input')
        .attr('placeholder', 'Type to search...');
}

export function updateRevisitOptions(options) {

    var $selectControl = options.controlSelector;
    $selectControl.empty();

    // Add blank option
    var option = $('<option>');
    $selectControl.append(option);

    options.data.forEach((activityCode) => {
        var selectOption = $('<option>')
            .val(activityCode.ID)
            .text(activityCode.Description)
            .addClass('')
            .attr('medicine', activityCode.Medicine)
            .attr('abbrv', activityCode.Abbreviation);
        if (options.nextActivityCode === activityCode.ID) {
            selectOption.attr('selected', 'selected');
        }
        $selectControl.append(selectOption);
    });
}

export function checkValidRevisit({ revisitDate, nextActivityID} = {}){

    if (nextActivityID == '0'){
        nextActivityID = '';
    }

    // Valid options are either both are blank, OR both are filled in
    if (
        (revisitDate != '' && nextActivityID != '') ||
        (revisitDate == '' && nextActivityID == '')
    ){
        return true;
    }

    let alertMessage = '"Revisit Date" and "Next Treatment"';
    alertMessage += ' are both required to save Revisit settings.';
    alertMessage += ' If Revisit is not required, reset both fields to blank.';

    EQLAPP.STRIPE.showAlert({
        title: 'Revisit Error - Missing Details',
        body: alertMessage,
    });

    return false;

}